<template>
  <div>
    <!-- begin #header -->
    <div id="header" class="header navbar-default">
      <!-- begin navbar-header -->
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle pull-right"
          v-on:click="toggleMobileRightSidebar"
          v-if="pageOptions.pageWithTwoSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <button
          type="button"
          class="navbar-toggle pull-left"
          v-on:click="toggleMobileSidebar"
          v-if="pageOptions.pageWithTwoSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <router-link to="/" class="navbar-brand">
          <a-icon type="home" :style="{ display: 'inline-flex' }" />
          {{ $root.appName }}
        </router-link>
        <button
          type="button"
          class="navbar-toggle"
          v-on:click="toggleMobileSidebar"
          v-if="
            !pageOptions.pageWithTwoSidebar &&
              !pageOptions.pageWithTopMenu &&
              !pageOptions.pageWithoutSidebar
          "
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <button
          type="button"
          class="navbar-toggle"
          v-on:click="toggleMobileTopMenu"
          v-if="pageOptions.pageWithTopMenu && pageOptions.pageWithoutSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <button
          type="button"
          class="navbar-toggle p-0 m-r-0"
          v-on:click="toggleMobileMegaMenu"
          v-if="pageOptions.pageWithMegaMenu"
        >
          <span class="fa-stack fa-lg text-inverse m-t-2">
            <i class="far fa-square fa-stack-2x"></i>
            <i class="fa fa-cog fa-stack-1x"></i>
          </span>
        </button>
      </div>
      <!-- end navbar-header -->

      <header-mega-menu v-if="pageOptions.pageWithMegaMenu"></header-mega-menu>

      <!-- begin header-nav -->
      <ul class="navbar-nav navbar-right">
        <li
          v-if="!pageOptions.pageWithLanguageBar"
          v-bind:class="{ 'hidden-sm': pageOptions.pageWithMegaMenu }"
        >
          <form class="navbar-form" v-on:submit="checkForm">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                placeholder="Enter keyword"
              />
              <button type="submit" class="btn btn-search">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </form>
        </li>
        <li class="dropdown navbar-user mr-2" v-if="branch">
          <a href="#" @click.prevent="onSwitch">
            <i class="fa fa-building ts-h-1"></i>
            <b class="ts-ml-2">{{ branch }}</b>
          </a>
          <!-- <b-dropdown
            :disabled="loading"
            variant="link"
            menu-class="dropdown-menu-right"
            class="user-dropdown-header"
          >
            <template slot="button-content">
              <i
                v-if="saving"
                class="fas fa-circle-notch d-inline-block spin"
              />
              <i v-else class="fa fa-building"></i>
              <span class="ml-2 d-none d-md-inline"
                ><b>{{ branch }}</b></span
              >
              <b class="caret"></b>
            </template>
            <b-dropdown-item
              href="#"
              v-for="(branch, index) in branchProfiles"
              :key="index"
              @click.prevent="pickDefaultBranch(branch)"
            >
              <span class="mr-2"><i class="far fa-building"></i></span>
              {{ branch.branch_name_en }}
            </b-dropdown-item>
          </b-dropdown> -->
        </li>
        <li class="dropdown navbar-user mr-2" v-if="warehouse">
          <a href="#">
            <i class="fas fa-warehouse ts-h-1"></i>
            <b class="ts-ml-2">{{ warehouse }}</b>
          </a>
        </li>
        <li class="dropdown">
          <b-dropdown
            variant="link"
            menu-class="media-list dropdown-menu-right"
            toggle-class="f-s-14"
          >
            <template slot="button-content">
              <i class="fa fa-bell"></i>
              <span class="label">0</span>
            </template>
            <b-dropdown-header>NOTIFICATIONS (0)</b-dropdown-header>
            <li class="text-center width-300 p-b-10">No notification found</li>
          </b-dropdown>
        </li>
        <li
          class="dropdown navbar-language"
          v-if="pageOptions.pageWithLanguageBar"
        >
          <b-dropdown variant="link" menu-class="p-b-0">
            <template slot="button-content">
              <span :class="`flag-icon flag-icon-${flag}`" :title="flag"></span>
            </template>
            <b-dropdown-item
              href="#"
              v-for="language in languages"
              :key="language.code"
              @click="changeLanguage(language)"
            >
              <span
                :class="`flag-icon flag-icon-${language.icon}`"
                :title="language.icon"
              ></span>
              {{ language.caption }}
            </b-dropdown-item>
          </b-dropdown>
        </li>
        <li class="dropdown navbar-user">
          <b-dropdown
            variant="link"
            menu-class="dropdown-menu-right"
            class="user-dropdown-header"
          >
            <template slot="button-content">
              <span class="d-none d-md-inline">{{ userName }}</span>
              <div class="image image-icon bg-black text-grey-darker">
                <img :src="userProfile" alt />
              </div>
              <b class="caret"></b>
            </template>
            <b-dropdown-item href="javascript:;">Edit Profile</b-dropdown-item>
            <b-dropdown-item href="javascript:;">
              <span class="badge badge-danger pull-right">2</span>
              Inbox
            </b-dropdown-item>
            <b-dropdown-item href="javascript:;">Calendar</b-dropdown-item>
            <b-dropdown-item href="javascript:;">Setting</b-dropdown-item>
            <b-dropdown-item @click.prevent="changePassword">{{
              $t('changePassword')
            }}</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item href="#" @click="logout">Log Out</b-dropdown-item>
          </b-dropdown>
        </li>
        <li
          class="divider d-none d-md-block"
          v-if="pageOptions.pageWithTwoSidebar"
        ></li>
        <li class="d-none d-md-block" v-if="pageOptions.pageWithTwoSidebar">
          <a
            href="javascript:;"
            v-on:click="toggleRightSidebar"
            data-click="right-sidebar-toggled"
            class="f-s-14"
          >
            <i class="fa fa-th"></i>
          </a>
        </li>
      </ul>
      <!-- end header navigation right -->
    </div>
    <!-- end #header -->
    <a-modal
      v-if="show_modal_change_pwd"
      v-model="show_modal_change_pwd"
      :title="$t('changePassword')"
      :centered="true"
      :maskClosable="false"
      :okText="$t('save')"
      :zIndex="1020"
      :confirmLoading="waiting"
      width="400px"
      @ok="onSave"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="required">{{ $t('user.oldPassword') }}</label>
            <input
              v-model="model.current_password"
              type="password"
              class="form-control"
              :class="{ 'is-invalid': errors.has('current_password') }"
            />
            <div class="invalid-feedback" v-if="errors.has('current_password')">
              {{ errors.first('current_password') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="required">{{ $t('user.newPassword') }}</label>
            <input
              v-model="model.new_password"
              type="password"
              class="form-control"
              :class="{ 'is-invalid': errors.has('new_password') }"
            />
            <div class="invalid-feedback" v-if="errors.has('new_password')">
              {{ errors.first('new_password') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="required">{{ $t('user.confirm') }}</label>
            <input
              v-model="model.new_password_confirmation"
              type="password"
              class="form-control"
              :class="{ 'is-invalid': errors.has('new_password_confirmation') }"
            />
            <div
              class="invalid-feedback"
              v-if="errors.has('new_password_confirmation')"
            >
              {{ errors.first('new_password_confirmation') }}
            </div>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal
      v-model="switchBranch"
      :centered="true"
      :title="$t('switchBranchLocation')"
      width="350px"
      :zIndex="1020"
      :maskClosable="false"
      :footer="null"
    >
      <ts-loading-banner :loading="loading">
        <div class="ts-space-y-4">
          <div class="row">
            <div class="col-md-12">
              <label class="required">{{ $t('branchName') }}</label>
              <div class="ts-border ts-border-blue-300 ts-p-2 ts-rounded">
                <a-radio-group
                  v-model="switchBranchModel.branch_id"
                  @change="getWarehouse"
                >
                  <a-radio
                    v-for="(branch, index) in branchProfiles"
                    :key="index"
                    :style="radioStyle"
                    :value="branch.branch_id"
                  >
                    {{ branch.branch_name_en }}
                  </a-radio>
                </a-radio-group>
              </div>
              <div class="validate" v-if="errors.has('branch_id')">
                {{ errors.first('branch_id') }}
              </div>
            </div>
          </div>
          <div class="row" v-if="locationList.length">
            <div class="col-md-12">
              <label class="required">{{ $t('location') }}</label>
              <div class="ts-border ts-border-blue-300 ts-p-2 ts-rounded">
                <a-radio-group v-model="switchBranchModel.location_id">
                  <a-radio
                    v-for="(location, index) in locationList"
                    :key="index"
                    :style="radioStyle"
                    :value="location.location_id"
                  >
                    {{ location.location_name_en }}
                  </a-radio>
                </a-radio-group>
              </div>
              <div class="validate" v-if="errors.has('location_id')">
                {{ errors.first('location_id') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 ts-flex ts-justify-end">
              <ts-button
                color="primary"
                :waiting="saving"
                @click.prevent="pickDefaultBranch"
              >
                {{ $t('switch') }}
              </ts-button>
            </div>
          </div>
        </div>
      </ts-loading-banner>
    </a-modal>
  </div>
</template>

<script>
import PageOptions from '../../config/PageOptions.vue'
import HeaderMegaMenu from './HeaderMegaMenu.vue'
import { Errors } from 'form-backend-validation'

export default {
  name: 'Header',
  components: {
    HeaderMegaMenu
  },
  data () {
    return {
      errors: new Errors(),
      pageOptions: PageOptions,
      show_modal_change_pwd: false,
      waiting: false,
      saving: false,
      loading: false,
      switchBranch: false,
      branchProfiles: [],
      locationList: [],
      switchBranchModel: {
        branch_id: null,
        location_id: null
      },
      model: {
        current_password: null,
        new_password: null,
        new_password_confirmation: null
      },
      languages: [
        { code: 'kh', icon: 'kh', caption: 'ខ្មែរ' },
        { code: 'en', icon: 'us', caption: 'English' }
      ],
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      }
    }
  },
  computed: {
    userProfile () {
      return null
    },
    userName () {
      return this.$store.state.authUser.user.name
    },
    flag () {
      if (this.$root.$i18n.locale === 'kh') return 'kh'
      else if (this.$root.$i18n.locale === 'en') return 'us'
    },
    branch () {
      return this.$store.state.authUser.user.default_branch
        ? this.$store.state.authUser.user.default_branch.branch_name_en
        : null
    },
    warehouse () {
      let wh = this.$store.state.authUser.user.warehouses
      if (wh) {
        let isDefault = wh.find(w => w.pivot.is_default == true)
          return isDefault ? isDefault.location_name_en : ''
      }

      return null
    }
  },
  created () {
    this.fetchBranch()
  },
  methods: {
    toggleMobileSidebar () {
      this.pageOptions.pageMobileSidebarToggled = !this.pageOptions
        .pageMobileSidebarToggled
    },
    toggleMobileRightSidebar () {
      this.pageOptions.pageMobileRightSidebarToggled = !this.pageOptions
        .pageMobileRightSidebarToggled
    },
    toggleMobileTopMenu () {
      this.pageOptions.pageMobileTopMenu = !this.pageOptions.pageMobileTopMenu
    },
    toggleMobileMegaMenu () {
      this.pageOptions.pageMobileMegaMenu = !this.pageOptions.pageMobileMegaMenu
    },
    toggleRightSidebar () {
      this.pageOptions.pageRightSidebarToggled = !this.pageOptions
        .pageRightSidebarToggled
    },
    checkForm: function (e) {
      e.preventDefault()
      this.$router.push({ path: '/extra/search' })
    },
    async logout () {
      PageOptions.pageEmpty = true
      await this.$store.dispatch('logout').then(() => {
        this.$router.push({ name: 'login' })
      })
    },
    changeLanguage (language) {
      this.$root.$i18n.locale = language.code
    },
    pickChild (child) {
      this.$store.commit('SET_SELECTED_STUDENT', child)
    },
    changePassword () {
      this.errors = new Errors()
      this.show_modal_change_pwd = true
    },
    async fetchBranch () {
      this.loading = true
      this.locationList = []
      await this.$store
        .dispatch('security/user/getBranchAssigned')
        .then(response => {
          this.branchProfiles = response.data
          this.switchBranchModel.branch_id = this.$store.state.authUser.user.default_branch.branch_id
        })

      await this.$store
        .dispatch('security/user/getWarehouseAssigned')
        .then(response => {
          this.locationList = response.data
          this.switchBranchModel.location_id = this.locationList
            .filter(l => l.is_default == true)
            .reduce((i, v) => (i = v.location_id), null)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getWarehouse () {
      this.loading = true
      this.$store
        .dispatch('security/user/getWarehouseAssigned', {
          branch_id: this.switchBranchModel.branch_id
        })
        .then(response => {
          this.locationList = response.data
          this.switchBranchModel.location_id = this.locationList
            .filter(l => l.is_default == true)
            .reduce((i, v) => (i = v.location_id), null)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSave () {
      this.waiting = true
      this.errors = new Errors()
      this.$store
        .dispatch('security/user/changePassword', this.model)
        .then(response => {
          this.show_modal_change_pwd = false
          this.$toasted.success(response.message)
          this.model.current_password = null
          this.model.new_password = null
          this.model.new_password_confirmation = null
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    pickDefaultBranch (branch) {
      this.saving = true
      this.errors = new Errors()
      this.$store
        .dispatch('security/user/switchDefaultBranch', this.switchBranchModel)
        .then(() => {
          this.logout()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.saving = false
        })
        .finally(() => {
          this.saving = false
        })
    },
    onSwitch () {
      this.switchBranch = true
    }
  }
}
</script>

<style scoped>
img {
  object-fit: cover;
  object-position: top;
  height: auto !important;
}
</style>

<style lang="sass">
@media (min-width: 768px)
  .header
    display: flex !important
    flex-direction: row !important
    align-items: center !important

    .navbar-header
      flex-grow: 1 !important

  .header .navbar-right
    display: flex !important
    flex-direction: row !important
    align-items: center !important

  .user-dropdown-header button
    display: flex !important
    justify-content: center !important
    align-items: center !important

    .image.image-icon
      margin: 0 3px !important
</style>
